module.exports = __webpack_public_path__ + "static/media/yellow-fever-news.a3050332.jpg";